import { render, staticRenderFns } from "./goodsListing.vue?vue&type=template&id=6401c6e0&scoped=true"
import script from "./goodsListing.vue?vue&type=script&lang=js"
export * from "./goodsListing.vue?vue&type=script&lang=js"
import style0 from "./goodsListing.vue?vue&type=style&index=0&id=6401c6e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401c6e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6401c6e0')) {
      api.createRecord('6401c6e0', component.options)
    } else {
      api.reload('6401c6e0', component.options)
    }
    module.hot.accept("./goodsListing.vue?vue&type=template&id=6401c6e0&scoped=true", function () {
      api.rerender('6401c6e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/productListingAndRemoval/goodsListing.vue"
export default component.exports